import React, { useState } from 'react';
import { formatAmount, formatAmountString } from '../utils/format';
import { useTranslation } from 'react-i18next';
import noImage from '../icons/noImageIcon.svg';
import ProductPopup from '../modules/Products/ProductPopup';



const ProductRow = ({ product, variant = 'default' }) => {
    const { t } = useTranslation();
    const [imageError, setImageError] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);

    const tva = parseFloat(process.env.REACT_APP_TVA);


    const handleImageError = (e) => {
        setImageError(true);
        e.target.src = noImage;
    };

    const originalTotalPrice = product.product.priceTTC * product.quantity;
    const unitPriceTTC = product.unitPrice * (1 + tva);

    const handleProductClick = (product) => {
        setSelectedProduct(product);
    };

    return (
        <div className="grid grid-cols-[30%_20%_20%_10%_20%] items-center bg-white p-2 rounded-[12px] shadow-[0px_6px_26px_rgba(98,107,125,0.07)]">
            <div className="flex items-center space-x-2"
                onClick={() => handleProductClick(product.product?.id)}
            >
                <div className="flex-none w-16 h-16 bg-white rounded-md shadow-[0px_6px_26px_rgba(98,107,125,0.07)] overflow-hidden flex items-center justify-center">
                    <img
                        src={product.product?.image}
                        alt="-"
                        className={`object-contain ${imageError ? 'w-1/2 h-1/2' : 'w-full h-full'}`}
                        onError={handleImageError}
                    />
                </div>
                <div>
                    <p className="text-[12px] font-semibold text-[#043F88]">
                        {product.product?.reference || 'N/A'}
                    </p>
                    <p className="text-primary font-semibold">
                        {product.product.name}
                    </p>
                    {product.changeRequestedBy && (
                        <p className="text-[#EF466F] text-[12px] font-semibold">
                            {product.changeRequestedBy === 'CLIENT' 
                                ? t('rows.requestedByClient')
                                : product.changeRequestedBy === 'WORKSHOP_MANAGER'
                                ? t('rows.requestedByWorkshopManager')
                                : product.changeRequestedBy}
                        </p>
                    )}
                </div>
            </div>


            {/* Price HT */}
            <div className="text-center">
                <p className="text-[#707070] text-[12px] font-semibold">
                    {t('rows.priceHT')}
                </p>
                {(
                    <p className="text-[#043F88] text-[20px] font-semibold">
                        {formatAmount(product.unitPrice || product.product.priceHT)}
                    </p>
                )}
            </div>

            {/* Price TTC */}
            <div className="text-center">
                <p className="text-[#707070] text-[12px] font-semibold">
                    {t('rows.priceTTC')}
                </p>
                {(
                    <p className="text-[#043F88] text-[20px] font-semibold">
                        {formatAmount(unitPriceTTC || product.product.priceTTC)}
                    </p>
                )}
            </div>

                        {/* Quantity */}
            <div className="text-center">
                <p className="text-[#707070] text-[12px] font-semibold">
                    {t('rows.quantity').toUpperCase()}
                </p>
                <p className="text-[#043F88] text-[20px] font-medium">
                    {product.quantity}
                </p>
            </div>


            {/* Total Price */}
            <div className="text-center">
                <p className="text-[#707070] text-[12px] font-semibold">
                    {t('rows.totalPrice')}
                </p>
                {(
                    <p className="text-[#043F88] text-[20px] font-semibold">
                        {formatAmount(unitPriceTTC * product.quantity || originalTotalPrice)}
                    </p>
                )}
                {product.advancePayment ? (
                    <p className="text-[12px] font-semibold text-[#06D6A0]">
                        {`AC: ${formatAmountString(product.advancePayment)}`}
                    </p>
                ) : null}
            </div>

            {selectedProduct && (
                <ProductPopup
                    productId={selectedProduct}
                    onClose={() => setSelectedProduct(null)}
                />
            )}
        </div>
    );
};

export default ProductRow;
